(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    



  class StickyHeader extends HTMLElement {



    constructor() {



      super();



      this.setHeaderHeight = this.setHeaderHeight.bind(this);



    }





    connectedCallback() {



      this.header = document.querySelector('.section-header');



      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');



      this.headerIsAlwaysSticky =

        this.getAttribute('data-sticky-type') === 'always' ||

        this.getAttribute('data-sticky-type') === 'reduce-logo-size';



      this.headerBounds = {};



      this.setHeaderHeight();



      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);



      if (this.headerIsAlwaysSticky) {



        this.header.classList.add('shopify-section-header-sticky');



      }



      this.currentScrollTop = 0;



      this.preventReveal = false;



      this.predictiveSearches = this.querySelectorAll('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);



      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);



      this.addEventListener(

        'preventHeaderReveal',

        this.hideHeaderOnScrollUp

      );



      window.addEventListener(

        'scroll',

        this.onScrollHandler,

        false

      );



      this.createObserver();



    }





    setHeaderHeight() {



      document.documentElement.style.setProperty(

        '--header-height',

        `${this.header.offsetHeight}px`

      );



    }





    disconnectedCallback() {



      this.mobileMediaQuery.removeEventListener(

        'change',

        this.setHeaderHeight

      );



      this.removeEventListener(

        'preventHeaderReveal',

        this.hideHeaderOnScrollUp

      );



      window.removeEventListener(

        'scroll',

        this.onScrollHandler

      );



    }





    createObserver() {



      let observer = new IntersectionObserver(

        (entries, observer) => {



          this.headerBounds = entries[0].intersectionRect;



          observer.disconnect();



        }

      );



      observer.observe(this.header);



    }





    onScroll() {



      const scrollTop =

        window.pageYOffset ||

        document.documentElement.scrollTop;





      if (

        [...this.predictiveSearches].some(

          (predictiveSearch) => predictiveSearch.isOpen

        )

      ) return;





      if (

        scrollTop > this.currentScrollTop &&

        scrollTop > this.headerBounds.bottom

      ) {



        this.header.classList.add(

          'scrolled-past-header'

        );



        if (this.preventHide) return;



        requestAnimationFrame(

          this.hide.bind(this)

        );





      } else if (

        scrollTop < this.currentScrollTop &&

        scrollTop > this.headerBounds.bottom

      ) {



        this.header.classList.add(

          'scrolled-past-header'

        );



        if (!this.preventReveal) {



          requestAnimationFrame(

            this.reveal.bind(this)

          );



        } else {



          window.clearTimeout(

            this.isScrolling

          );



          this.isScrolling =

            setTimeout(() => {



              this.preventReveal = false;



            }, 66);



          requestAnimationFrame(

            this.hide.bind(this)

          );



        }





      } else if (

        scrollTop <= this.headerBounds.top

      ) {



        this.header.classList.remove(

          'scrolled-past-header'

        );



        requestAnimationFrame(

          this.reset.bind(this)

        );



      }





      this.currentScrollTop = scrollTop;



    }





    hide() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add(

        'shopify-section-header-hidden',

        'shopify-section-header-sticky'

      );



      this.closeMenuDisclosure();



      this.closeSearchModal();



    }





    reveal() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add(

        'shopify-section-header-sticky',

        'animate'

      );



      this.header.classList.remove(

        'shopify-section-header-hidden'

      );



    }





    reset() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.remove(

        'shopify-section-header-hidden',

        'shopify-section-header-sticky',

        'animate'

      );



    }





    closeMenuDisclosure() {



      this.disclosures =

        this.disclosures ||

        this.header.querySelectorAll(

          'header-menu'

        );



      this.disclosures.forEach(

        (disclosure) => disclosure.close()

      );



    }





    closeSearchModal() {



      this.searchModals =

        this.searchModals ||

        this.header.querySelectorAll(

          'details-modal'

        );



      this.searchModals.forEach(

        (searchModal) =>

          searchModal.close(false)

      );



    }



  }





  document.addEventListener(



    'open',



    (event) => {



      if (

        !(event.target instanceof HTMLElement) ||

        !event.target.matches(

          'shopify-account'

        )

      ) return;





      const bottom = Math.max(

        0,

        Math.round(

          event.target

            .getBoundingClientRect()

            .bottom

        )

      );





      event.target.style.setProperty(

        '--account-dialog-top',

        `${bottom}px`

      );



    },



    true



  );





  customElements.define(

    'sticky-header',

    StickyHeader

  );




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["localita-noleggio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value
      .toLocaleLowerCase('it')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    const initialize = (root) => {
      if (!root || root.dataset.localitaReady === 'true') return;
      root.dataset.localitaReady = 'true';

      const search = root.querySelector('[data-localita-search]');
      const clear = root.querySelector('[data-localita-clear]');
      const filters = [...root.querySelectorAll('[data-localita-filter]')];
      const cards = [...root.querySelectorAll('[data-localita-card]')];
      const count = root.querySelector('[data-localita-count]');
      const empty = root.querySelector('[data-localita-empty]');
      const expandWrap = root.querySelector('[data-localita-expand-wrap]');
      const expandButton = root.querySelector('[data-localita-expand]');
      const expandText = root.querySelector('[data-localita-expand-text]');
      const initialLimit = Math.max(1, Number.parseInt(root.dataset.localitaLimit || '10', 10));
      const expandLabel = root.dataset.localitaExpandLabel || 'Mostra tutte le località';
      const collapseLabel = root.dataset.localitaCollapseLabel || 'Mostra meno';
      let activeRegion = 'all';
      let expanded = false;

      const update = () => {
        const query = normalize(search ? search.value : '');
        const matches = cards.filter((card) => {
          const regionMatches = activeRegion === 'all' || card.dataset.region === activeRegion;
          const searchMatches = normalize(card.dataset.search || '').includes(query);
          return regionMatches && searchMatches;
        });
        const limitResults = !query && !expanded;

        cards.forEach((card) => {
          const matchIndex = matches.indexOf(card);
          const show = matchIndex !== -1 && (!limitResults || matchIndex < initialLimit);
          card.hidden = !show;
        });

        if (count) {
          if (matches.length === 1) {
            count.textContent = '1 località trovata';
          } else {
            count.textContent = `${matches.length} località trovate`;
          }
        }

        const canExpand = !query && matches.length > initialLimit;
        if (expandWrap) expandWrap.hidden = !canExpand;
        if (expandButton) expandButton.setAttribute('aria-expanded', String(expanded));
        if (expandText) expandText.textContent = expanded ? collapseLabel : expandLabel;
        if (empty) empty.hidden = matches.length !== 0;
        if (clear) clear.hidden = !query;
      };

      if (search) {
        search.addEventListener('input', () => {
          expanded = false;
          update();
        });
      }

      if (clear) {
        clear.addEventListener('click', () => {
          search.value = '';
          search.focus();
          expanded = false;
          update();
        });
      }

      if (expandButton) {
        expandButton.addEventListener('click', () => {
          expanded = !expanded;
          update();
        });
      }

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          activeRegion = filter.dataset.localitaFilter;
          expanded = false;
          filters.forEach((item) => {
            const selected = item === filter;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          update();
        });
      });

      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-localita-directory]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mappa-localita-perugia"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-perugia-places]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const filterButtons = section.querySelectorAll('[data-filter]');
    const places = section.querySelectorAll('[data-place]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        places.forEach((place) => { place.hidden = filter !== 'all' && place.dataset.zone !== filter; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mappa-localita-ravenna"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ravenna-places]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const filterButtons = section.querySelectorAll('[data-filter]');
    const places = section.querySelectorAll('[data-place]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        places.forEach((place) => { place.hidden = filter !== 'all' && place.dataset.zone !== filter; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mappa-provincia-taranto"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-taranto-atlas]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const filterButtons = section.querySelectorAll('[data-filter]');
    const places = section.querySelectorAll('[data-place]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        places.forEach((place) => { place.hidden = filter !== 'all' && place.dataset.zone !== filter; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
